module.exports = __webpack_public_path__ + "assets/photo.gif";


//////////////////
// WEBPACK FOOTER
// ./images/photo.gif
// module id = 563
// module chunks = 0